import React from "react";
import AllRoute from "../router";
import Footer from "../components/footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import ScrollProgress from "../components/ScrollProgress/ScrollProgress";
import AnimatedBackground from "../components/AnimatedBackground/AnimatedBackground";
import ScrollToTop from "../components/ScrollToTop";

const App = () => {
  return (
    <div className="App" id="scrool">
      <ScrollToTop />
      <AnimatedBackground />
      <ScrollProgress />
      <Navbar hclass={"wpo-header-style-2"} topbarNone={"topbar-none"} />
      <AllRoute />
      <Footer />
    </div>
  );
};

export default App;
